export default __webpack_public_path__ + "static/media/live_world.0252acd4.png";